import { render } from "./CustomPinnedRowCellRenderer.vue?vue&type=template&id=1fb8fd5c&ts=true"
import script from "./CustomPinnedRowCellRenderer.vue?vue&type=script&lang=ts"
export * from "./CustomPinnedRowCellRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mitliv/wp-content/themes/wp-mitliv-theme/resources/views/backend/statistics/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__